import {
	GetActivePlayerRequest,
	GetActivePlayerResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getActivePlayer } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetActivePlayer(
	payload: GetActivePlayerRequest,
	props?: UseBaseQueryOptions<GetActivePlayerResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetActivePlayer, payload],
		queryFn: () => getActivePlayer(payload),
		...props,
	})
}
